module.exports = __webpack_public_path__ + "img/DNADamage-PRCA_10X_ACC.1989e9b9.png";